import { render, staticRenderFns } from "./MiniviewCreated.vue?vue&type=template&id=402856ca"
import script from "./MiniviewCreated.vue?vue&type=script&lang=js"
export * from "./MiniviewCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports